module.exports = __webpack_public_path__ + "static/img/avatar-s-10.64aa61a3.jpg";